import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export function isDocumentDefined() {
  return typeof window !== 'undefined' && 'document' in window;
}
export function extractTransformProperties(domElement) {
  if (!domElement) {
    return {};
  }
  var computedStyle = window.getComputedStyle(domElement);
  var transform = computedStyle.getPropertyValue('transform');
  var match = transform.match(/matrix\(([^,]+), ([^,]+), ([^,]+), ([^,]+), ([^,]+), ([^)]+)\)/);
  if (match) {
    var _match$map = match.map(parseFloat),
      _match$map2 = _slicedToArray(_match$map, 7),
      scaleX = _match$map2[1],
      skewY = _match$map2[2],
      skewX = _match$map2[3],
      scaleY = _match$map2[4],
      translateX = _match$map2[5],
      translateY = _match$map2[6];
    return {
      scaleX: scaleX,
      skewY: skewY,
      skewX: skewX,
      scaleY: scaleY,
      translateX: translateX,
      translateY: translateY
    };
  }
  return {};
}
export function listenToStyleDomChanges(domElement, callbackFunction) {
  var observer = new MutationObserver(callbackFunction);
  observer.observe(domElement, {
    attributes: true,
    attributeFilter: ['style']
  });
  return observer;
}